module.exports = __webpack_public_path__ + "img/4-3.50d8c128.jpg";